var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWaleeMerchant = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 162.901,
    viewBox: "0 0 294 162.901",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(-16.317 -14.868)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Walee_Merchant_Portal",
    "data-name": "Walee Merchant Portal",
    transform: "translate(16.317 168.769)",
    fill: "#111",
    fontSize: 25,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Walee Merchant Portal")), /*#__PURE__*/React.createElement("g", {
    id: "Group_2464",
    "data-name": "Group 2464",
    transform: "translate(123.317 14.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M429.835,216.505H356.709A2.779,2.779,0,0,0,354,219.35v59.865a6.213,6.213,0,0,0,3.356,5.582l33.38,16.712a5.653,5.653,0,0,0,5.074,0l33.38-16.712a6.21,6.21,0,0,0,3.352-5.582V219.35a2.776,2.776,0,0,0-2.705-2.845ZM393.223,259.52a17.556,17.556,0,0,1-6.781,6.446,15.311,15.311,0,0,1-17.555-2.5,13.027,13.027,0,0,1-.306-18.42q.4-.41.828-.784a15.149,15.149,0,0,1,20.445.493l1.546,1.528a.592.592,0,0,1,.032.819l-8,9.122a1.027,1.027,0,0,1-1.382.123L378.64,253.7a.883.883,0,0,1-.185-1.234c.016-.021.032-.041.05-.061l4.461-5.092a8.467,8.467,0,0,0-9.484,1.6,7.548,7.548,0,0,0-.025,10.359c4.024,4.287,8.762,3.536,12.913-.12a28.359,28.359,0,0,0,5.052-6.1l4.2,2.933C394.685,257.288,393.872,258.511,393.223,259.52Zm24.673,3.948a15.142,15.142,0,0,1-20.442.492l-1.653-1.473a.585.585,0,0,1-.069-.819l7.562-9.309a1.023,1.023,0,0,1,1.375-.171l3.516,2.522a.882.882,0,0,1,.233,1.226c-.015.021-.031.043-.047.063l-4.133,5.089a8.457,8.457,0,0,0,9.024-1.751,7.273,7.273,0,0,0,.173-10.284q-.223-.23-.465-.44c-5.665-5.051-11.745.236-15.993,5.589l-4.3-3c.084-.123.167-.247.255-.374,2.369-3.4,5.617-8.19,10.02-9.708a15.052,15.052,0,0,1,14.412,3.142,13.024,13.024,0,0,1,1.316,18.372q-.375.433-.787.831Z",
    transform: "translate(-353.999 -182.308)",
    fill: "#6631f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M445.145,185.691l1.747-4.486c-5.376-2.962-7.21-7.485-5.476-13.624l-9.41-4.01c-2.978,5.356-7.456,7.306-13.628,5.52-1.611,3.752-3.214,7.456-4.788,11.175-2.354,5.572-2.347,5.579-8.313,5.414-.229-.007-.463-.054-1.007-.123,1.077-2.566,2.114-5.051,3.159-7.528q4.23-10.043,8.474-20.085c1.99-4.672,5.348-6.042,10.025-4.076q13.395,5.626,26.776,11.3c4.475,1.9,5.918,5.513,3.965,9.9-1.336,3-2.782,5.949-4.013,8.993a2.25,2.25,0,0,1-2.6,1.662C448.512,185.611,446.953,185.691,445.145,185.691Z",
    transform: "translate(-377.199 -152.998)",
    fill: "#6631f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M383.191,188.374c1.055-4.071,2.1-8.131,3.163-12.189,1.028-3.923,2.025-7.857,3.136-11.757,1.151-4.05,4.694-5.839,8.9-4.473l-7.114,16.794q-2.1,4.96-4.2,9.913C386.111,188.927,386.1,188.923,383.191,188.374Z",
    transform: "translate(-367.471 -156.001)",
    fill: "#6631f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M376.407,165.995l-6.774,25.532h-2.765c.624-4.88,1.239-9.714,1.864-14.549.24-1.854.477-3.711.778-5.558A6.264,6.264,0,0,1,376.407,165.995Z",
    transform: "translate(-359.938 -158.991)",
    fill: "#6631f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M431.839,206.474c-.065-2.92,2.186-5.331,5.459-5.883a8.959,8.959,0,0,1,9.752,5.883Z",
    transform: "translate(-389.923 -174.919)",
    fill: "#6631f7"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaleeMerchant, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/walee-merchant.b2ca0921.svg";
export { ForwardRef as ReactComponent };